import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import './ResultPage.css';
import { API_BASE_URL } from '../config';

function ResultPage({ courses, selectedCourses }) {
  const navigate = useNavigate();
  const selectedCoursesDetails = courses.filter(course =>
    selectedCourses.includes(course.course_code) // 英語キーに変更
  );
  const [isProcessing, setIsProcessing] = useState(false);

  const handleBack = () => {
    navigate('/courses');
  };

  // /api/judge に送信するデータを作成
  const coursesForJudgment = selectedCourses.map(code => ({ course_code: code }));

  return (
    <div className="App">
      <header className="App-header">
        <div className="header-content">
          <div className="header-info">
            <h1
              className="header-title clickable-title"
              onClick={() => navigate('/')}
            >
              選択した授業一覧
            </h1>
            <p>選択した授業数: {selectedCoursesDetails.length}</p>
          </div>
          <button
            className="home-button"
            onClick={() => navigate('/')}
          >
            ホームに戻る
          </button>
        </div>
      </header>
      <main className="result-container">
        <h2>選択した授業一覧</h2>
        <div className="selected-courses-grid">
          {selectedCoursesDetails.map((course) => (
            <div key={course.course_code} className="selected-course-card">
              <div className="course-header">
                <h3>{course.name}</h3>
                <span className="course-code">{course.course_code}</span>
              </div>
              <div className="course-details">
                <div className="detail-row">
                  <span className="detail-label">担当教員</span>
                  <span className="detail-value">{course.instructor}</span>
                </div>
                {/* <div className="detail-row">
                  <span className="detail-label">開講時期</span>
                  <span className="detail-value">{course.term}</span>
                </div> */}
                <div className="detail-row">
                  <span className="detail-label">時間割</span>
                  <span className="detail-value">{course.day_of_week}曜{course.period}限</span>
                </div>
                {/* <div className="detail-row">
                  <span className="detail-label">標準年次</span>
                  <span className="detail-value">{course.standard_year}年次</span>
                </div> */}
              </div>
            </div>
          ))}
        </div>
        <div className="action-buttons">
          <button
            className="modify-button"
            onClick={handleBack}
          >
            修正する
          </button>
          <button
            className="judge-button"
            onClick={async () => {
              setIsProcessing(true);
              try {
                const response = await fetch(`${API_BASE_URL}/api/judge`, {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    courses: coursesForJudgment // 修正: course_code のリストの辞書を送る
                  }),
                });
                
                if (!response.ok) {
                  const errorData = await response.json().catch(() => ({ detail: '判定処理に失敗しました。詳細不明。' }));
                  throw new Error(errorData.detail || '判定処理に失敗しました');
                }
                
                const result = await response.json();
                // 判定結果ページに遷移
                // JudgmentResultPage に渡す courses も、表示に必要な情報を持つ形式に合わせる必要がある
                // ここでは selectedCoursesDetails (英語キーだが情報は限定的) を渡している
                navigate('/judgment', {
                  state: {
                    judgmentResult: result,
                    courses: selectedCoursesDetails // この courses は表示用。キーは英語になっている。
                  }
                });
              } catch (error) {
                console.error('Error:', error);
                alert('エラーが発生しました。\n' + error.message);
              } finally {
                setIsProcessing(false);
              }
            }}
            disabled={isProcessing}
          >
            {isProcessing ? '処理中...' : '判定する'}
          </button>
        </div>
      </main>
    </div>
  );
}

export default ResultPage;